'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _liveCatalogStatus = require('./remote/liveCatalogStatus');

var LiveCatalogStatus = {
    fetchLiveCatalogStatus: _liveCatalogStatus.LiveCatalogStatusRemote.fetchLiveCatalogStatus
};

exports.default = LiveCatalogStatus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/liveCatalogStatus.js
// module id = CwSH
// module chunks = 60